<template>
  <i v-if="isRelevant" class="tm-visual-audio-gap" title="Visual gap">
    <i
      v-for="(rectangle, i) in gapRectangles"
      :key="i"
      class="-gap"
      :style="getGapStyle(rectangle)"
    >
      <gap-mark class="-mark" />
    </i>
  </i>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import GapMark from './gap_mark.vue.svg';
import gridMixin from '../grid.mixin';

export default {
  name: 'tm-visual-audio-gap',
  mixins: [gridMixin],
  components: {
    GapMark,
  },

  data() {
    return {
      gapRectanglesCache: [],
    };
  },

  computed: {
    ...mapState('timemachine', {
      pxRowBlankTop: (state) => state.cssVariables.pxRowBlankTop,
      MODE_VA_GAP_VISIBLE: (state) => state.MODE.VA_GAP_VISIBLE,
    }),
    ...mapGetters('timemachine', ['hasVisualGap']),

    isRelevant() {
      return this.MODE_VA_GAP_VISIBLE && this.hasVisualGap;
    },

    gapRectangles() {
      if (this.gridEstablished) {
        return this.$_time2rectangles(
          this.trackLayer.visualDuration,
          this.trackLayer.audioDuration,
          false
        );
      } else {
        return this.gapRectanglesCache;
      }
    },
  },

  watch: {
    gapRectangles: {
      immediate: false,
      handler(value) {
        this.gapRectanglesCache = value;
      },
    },
  },

  methods: {
    getGapStyle(r) {
      return {
        transform: `translate3d(${r.p1.x}px, ${
          r.p1.y + this.pxRowBlankTop
        }px, 0)`,
        width: `${r.width}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.tm-tracks > .tm-visual-audio-gap {
  > .-gap {
    position: absolute;
    top: 0;
    height: 2px;
    background-color: $color-pink-d;
    z-index: var(--tm-zGapIndicator);

    > .-mark {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -25px);
    }
  }
}
</style>
